import * as React from 'react';
import classnames from 'classnames';
import { Portal } from 'react-portal';
import { themr } from 'react-css-themr';
import menuTheme from './Menu.scss';
import { KeyEventHandler } from 'common/components/core/util/KeyEventsHandler';
import HandleOutsideClick from 'common/components/core/util/HandleOutsideClick';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { SlideDown } from 'common/components/core/animations';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import {
    PopoverPlaceEnum,
    PopoverTriggerEnum
} from 'common/components/core/popover/popOverFactory';

import { SubMenuContent as SubMenuContentComponent } from './SubMenuContent';

const MenuTitleComponent = ({ theme, menuTitle, upperCase }) => {
    return menuTitle ? (
        <DivWithPopover
            preferPlace={PopoverPlaceEnum.Above}
            triggerPopoverOn={PopoverTriggerEnum.Hover}
            popOverContent={menuTitle}
            className={classnames(theme.menuTitle, {
                [theme.upperCase]: upperCase
            })}
        >
            {menuTitle}
        </DivWithPopover>
    ) : null;
};

const menuFactory = ({
    SubMenuTitle = MenuTitleComponent,
    SubMenuContent = SubMenuContentComponent
}) => {
    class Menu extends React.Component {
        static defaultProps = {
            transitionName: SlideDown,
            transitionAppearTimeout: 300,
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300
        };
        constructor(props) {
            super(props);
            this.state = {
                hoveredItem: {}
            };
        }
        onItemClick = (item, event) => {
            this.props.onItemClick && this.props.onItemClick(item, event);
        };
        onItemMouseEnter = (item, event) => {
            this.setState({ hoveredItem: item });
            this.props.onItemMouseEnter &&
                this.props.onItemMouseEnter(item, event);
        };
        onItemMouseLeave = (item, event) => {
            this.setState({ hoveredItem: {} });
            this.props.onItemMouseLeave &&
                this.props.onItemMouseLeave(item, event);
        };
        getMenuRef = ref => {
            this.props.getMenuRef && this.props.getMenuRef(ref);
        };

        render() {
            const {
                style,
                theme,
                className,
                isOpen,
                transitionName,
                getDropdownMenuRef,
                transitionAppearTimeout,
                transitionEnterTimeout,
                transitionLeaveTimeout,
                menuTitle,
                menuTitleInUpperCase,
                testId,
                ...others
            } = this.props;
            const { hoveredItem } = this.state;
            //keyboard, outside and esc
            return (
                <Portal ref={getDropdownMenuRef}>
                    <CSSTransitionGroup
                        transitionName={transitionName}
                        transitionAppear
                        testId={testId}
                        transitionAppearTimeout={transitionAppearTimeout}
                        transitionEnterTimeout={transitionEnterTimeout}
                        transitionLeaveTimeout={transitionLeaveTimeout}
                    >
                        {isOpen ? (
                            <div
                                key="1"
                                style={style}
                                ref={this.getMenuRef}
                                className={classnames(
                                    theme.menuWrap,
                                    className,
                                    {
                                        [theme.isOpen]: isOpen
                                    }
                                )}
                            >
                                <span className={theme.listArrow} />
                                <SubMenuTitle
                                    menuTitle={menuTitle}
                                    upperCase={menuTitleInUpperCase}
                                    theme={theme}
                                />
                                <SubMenuContent
                                    {...others}
                                    theme={theme}
                                    hoveredItem={hoveredItem}
                                    onItemClick={this.onItemClick}
                                    onItemMouseEnter={this.onItemMouseEnter}
                                    onItemMouseLeave={this.onItemMouseLeave}
                                />
                            </div>
                        ) : null}
                    </CSSTransitionGroup>
                </Portal>
            );
        }
    }
    const ThemedMenu = themr('Menu', menuTheme)(Menu);
    return HandleOutsideClick(KeyEventHandler(ThemedMenu));
};

const EnhancedMenu = menuFactory({});

export { menuFactory, EnhancedMenu as Menu };

export default EnhancedMenu;
